<script lang="ts">
  import Button from '$components/button/Button.svelte';
  import Page from '$components/page/Page.svelte';
  import { openModal } from '$components/bottom-sheet/index.svelte';
  import Logo from '$components/Logo.svelte';
  import PWAPrompt from '$components/pwa-prompt/PWAPrompt.svelte';
  import FollowOnScreenPrompts from '$modals/follow-on-screen-prompts/FollowOnScreenPrompts.svelte';
  import Image from '$lib/assets/people-touching-hands.webp';
  import CirclesLogo from '$lib/assets/circles-logo.webp';
  import BuiltByGnosis from '$lib/assets/built-by-gnosis.webp';
  import { runningAsStandalone } from '$utils/runningAsStandalone';
  import { connectWalletAndStoreData } from '$utils/connectWalletAndStoreData';
  import EnvioSwitcher from '$modals/envio/EnvioSwitcher.svelte';
  import { onDestroy, onMount } from 'svelte';
  import LegacyV1SignUp from '$modals/legacy-v1-signup/LegacyV1SignUp.svelte';
  import CirclesRpcSwitcher from '$modals/circles-rpc/CirclesRpcSwitcher.svelte';
  import IconArrowRight from '$lib/icons/IconArrowRight.svelte';
  import { goToTransition } from '$utils/goToTransition';

  let standalone = $derived(runningAsStandalone());

  const connectExistingWallet = (): void => {
    connectWalletAndStoreData('/migrate-domain');
    openModal(FollowOnScreenPrompts);
  };

  onMount(() => {
    document.addEventListener('keydown', keydown);
  });

  onDestroy(() => document.removeEventListener('keydown', keydown));

  const keydown = (event: KeyboardEvent) => {
    const href = window.location.href;

    if (
      !href.includes('kitchen') &&
      !href.includes('localhost') &&
      !href.includes('deploy-preview')
    ) {
      return;
    }

    const cmdOrCtrl = event.metaKey || event.ctrlKey;

    if (cmdOrCtrl && event.shiftKey && event.key === 'k') {
      event.preventDefault();
      openModal(LegacyV1SignUp);
    }
  };
</script>

<Page>
  {#snippet top()}
    <PWAPrompt />
  {/snippet}
  {#snippet middle({ height })}
    <div
      class="relative grid h-full grid-rows-[auto_1fr] bg-background-welcome dark:bg-background"
      class:pt-safe={standalone}
      style="height: {height}px"
      role="presentation">
      <div class="flex justify-between px-gno-page pt-4">
        <Logo height="h-4" />
        <img src={BuiltByGnosis} alt="Gnosis" class="h-4 dark:invert" height="40" />
      </div>
      <div class="grid h-full place-items-center pb-[20%]">
        <div class="text-center">
          <img
            src={CirclesLogo}
            alt="Circles"
            class="mb-4 inline-block h-8 dark:grayscale-100 dark:brightness-1000"
            height="64" />
          <h2 class="typography-h2-semibold my-2">Money, Reimagined</h2>
          <p class="typography-body-l-medium text-foreground-muted">
            Create a new wallet or log in to access<br />Metri and Circles.
          </p>
        </div>
      </div>
      <div class="absolute bottom-0 left-0 h-auto w-full">
        <img
          src={Image}
          alt="Metri"
          class="object-contain dark:brightness-70 dark:contrast-150"
          height="475" />
      </div>
    </div>
  {/snippet}
  {#snippet bottom()}
    <div class="grid gap-3 px-gno-page pb-gno-bottom-space pt-6">
      <Button
        ariaLabel="Login with Passkey"
        stretched
        fullOpacityIcon={true}
        onclick={connectExistingWallet}
        variant="primary"
        testid="import-metri-account-button">
        Login with Passkey</Button>
      <Button
        ariaLabel="Go to Gnosis"
        stretched
        fullOpacityIcon={true}
        onclick={() => goToTransition('right', '/migrate-domain')}
        variant="tertiary"
        testid="import-metri-account-button">
        Continue to Gnosis <IconArrowRight class="size-5" /></Button>
      <span class="typography-body-s-regular text-center text-foreground-subtle">
        <!-- svelte-ignore a11y_missing_attribute -->
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <a ondblclick={() => openModal(EnvioSwitcher)}>By</a>
        using Metri, you
        <!-- svelte-ignore a11y_missing_attribute -->
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <a ondblclick={() => openModal(CirclesRpcSwitcher)}>agree</a>
        to accept our
        <a href="/terms_and_conditions_metri.pdf" target="_blank" class="text-foreground">
          Terms of Use
        </a>
        and
        <a
          href="https://assets-global.website-files.com/6605b457e1a6f8ff52020db9/664c40d17ebfbe1243794c3a_Metri_Privacy_Policy_May24.pdf"
          target="_blank"
          class="text-foreground">
          Privacy Policy.
        </a>
      </span>
    </div>
  {/snippet}
</Page>
